import { useNavigate } from 'react-router-dom';

// import fb from 'assets/images/fb-icon.svg';

import { RegisterForm } from './RegisterForm';
// import LoginGoogle from 'components/LoginGoogle';

function ButtonRadio({ value, name, selected, onChange }: { value: string, name: string, selected: boolean, onChange: (value: string) => void }) {
    return (
        <button
            className="flex items-center cursor-pointer"
            onClick={() => {
                if (!selected) {
                    onChange(value)
                }
            }}
        >
            <input onChange={() => {}} id={value} type="radio" checked={selected} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-0 dark:bg-gray-700 dark:border-gray-600" />
            <span className="ms-2 text-sm text-gray-900 dark:text-gray-300">{name}</span>
        </button>
    )
}

export function RegisterBody({ userType }: { userType: string }) {
    const navigate = useNavigate();

    // const handleFacebookSignup = () => {
    //     // Handle Facebook sign up logic here
    // };

    return (
        <>
            <div className='flex flex-col items-center'>
                <h1 className="text-2xl font-medium mb-8">Sign Up With Crafttatva</h1>
                <div className='flex gap-10 mb-5'>
                    <ButtonRadio
                        value="artist"
                        name="Artist"
                        selected={userType === "artist"}
                        onChange={() => navigate('/register')}
                    />
                    {/* <ButtonRadio
                        value="gallery"
                        name="Gallery"
                        selected={userType === "gallery"}
                        onChange={() => navigate('/register/gallery')}
                    /> */}
                
                </div>
                {/* <div className='flex w-full gap-6'>
                    <LoginGoogle type="register" registerType={userType} />
                    
                    <button type="button" onClick={handleFacebookSignup} className="flex-1 text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-0 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-xs px-5 py-2.5 text-center flex items-center justify-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">
                        <img src={fb} className='w-5 h-5 me-2' alt="Sign up with Facebook" />
                        Sign Up with Facebook
                    </button>
                </div>
                <div className='w-full flex items-center gap-4 mt-6 mb-6'>
                    <hr className='grow bg-gray-200 border-t dark:bg-gray-700' />
                    <span className='text-xs text-gray-600 dark:text-gray-300'>Or Sign Up Using Email</span>
                    <hr className='grow bg-gray-200 border-t dark:bg-gray-700' />
                </div> */}
                <RegisterForm userType={userType}/>
                <span className='block mt-4 text-sm font-light'>
                    {/* Create your Seller <b className='font-semibold'>Artist / Gallery</b> account */}
                    Already have account?
                    <button onClick={() => navigate('/login')} className='ms-1 font-semibold text-red-700 underline cursor-pointer'>Login</button>
                </span>
            </div>
        </>
    );
}

export default RegisterBody;